import APIEndpoints from "./APIEndpoints";
import hit from "./hit";

const createSignedUrlForShowBackground = () => hit(APIEndpoints.ASSETS.CREATE_SIGNED_URL_FOR_SHOW);

export default {
  createSignedUrlForShowBackground,
};
